import { useNavigate } from 'react-router'
import { Card } from '@sainsburys-tech/luna-card'
import { IDraft } from '../../../types/Drafts/IDraftsTypes'
import Title from '../Components/Title'
import IncidentDescription from '../Components/IncidentDescription'
import { useState } from 'react'
import PromptComponent from '../../Reporting/ComponentSwitch/Components/PromptComponent'
import IconComponent from '../../Reporting/ComponentSwitch/Components/IconComponent'
import { Body1 } from '@sainsburys-tech/luna-typography'
import getDraftIncidentCategory from '../../../utils/getDraftIncidentCategory'

const DraftCard = ({ draft }: IDraft) => {
  const [showPrompt, setShowPrompt] = useState(false)

  const responses = JSON.parse(draft.session.responseStorage)

  const incidentCategory = getDraftIncidentCategory({draft:draft}) ?? null
  const incidentDate = responses?.security?.responses?.incident_date ?? null
  const incidentTime = responses?.security?.responses?.incident_time ?? null
  const incidentLocation = responses?.security?.responses?.incident_location ?? null
  const incidentStore = draft.locationName ?? null
  const incidentCategoryText = incidentCategory ? (' - ' + incidentCategory) : ''

  const navigateTo = useNavigate()

  function continueSession() {
    sessionStorage.setItem('draftId', draft.id )
    navigateTo('/reporting')
  }

  function handlePromptResponse (response: boolean) {
    setShowPrompt(false)
    if (response) {
      continueSession()
    }
  }

  return (
    <>
    {showPrompt ? <PromptComponent 
      title={'Continue draft'} 
      body={'Do you want to continue where you left off?'} 
      text={'Continue'} 
      icon={<IconComponent value={'BlueInfoIcon'}/>} 
      handleResult={handlePromptResponse} />
    : null}
    
    {draft.type ? 
    <Card className="s-reported-accident-card rln-c-card ln-c-card--soft ln-u-margin-bottom*2 ln-u-margin-left s-card-clickable" onClick={() => setShowPrompt(true)}>
      <Title
        text={draft.type.replaceAll('_', ' ') + (incidentCategoryText) } 
      />
      <IncidentDescription
        dateOfIncident={incidentDate ? new Date(incidentDate) : null}
        timeOfIncident={incidentTime ?? null}
        location={incidentLocation ? incidentLocation : null }
        store={incidentStore ? incidentStore : null}
        type={"draft"}
      />
    </Card> 
    : 
    
    <Card className="s-reported-accident-card rln-c-card ln-c-card--soft ln-u-margin-bottom*2 ln-u-margin-left s-card-clickable s-card-faded" onClick={() => setShowPrompt(true)}>
      <Title
        text={'Not yet started'}
      />
      <Body1 className="ln-u-color-dark">
        Click here to start this draft</Body1>
    </Card>
    }
    </>
  )
}

export default DraftCard
